import { HTMLAttributes, PropsWithChildren, ReactElement } from 'react';

import { styled } from '@mui/material';
import clsx from 'clsx';

import { SxProps, WithRef } from '../../../types';
import { shouldForwardProp } from '../../../utils/shouldForwardProp';

/**
 * @deprecated `Paper` is deprecated — use `Panel` from `@cast/design-system`
 * instead, or `ChoicePanel` where `hoverable` is `true`.
 */
export type PaperProps = PropsWithChildren<
  {
    sx?: SxProps;
    testId?: string;
  } & HTMLAttributes<HTMLDivElement>
>;

/**
 * @deprecated Use `Panel` from `@cast/design-system` instead
 */
export const Paper = styled(
  ({
    ref,
    className,
    children,
    testId,
    ...rest
  }: WithRef<HTMLDivElement, PaperProps>) => {
    return (
      <div
        ref={ref}
        className={clsx('DsPaper-Root', className)}
        data-testid={testId}
        {...rest}
      >
        {children}
      </div>
    );
  },
  {
    name: 'DsPaper',
    slot: 'Root',
    target: 'DsPaper-Root',
    shouldForwardProp,
    overridesResolver: (_, styles) => [styles.root],
  }
)<PaperProps>`` as unknown as (props: PaperProps) => ReactElement;
